import React from 'react';
import styled from 'styled-components/macro';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import ErrorIcon from '@material-ui/icons/ErrorOutlined';
import { makeStyles } from '@material-ui/core';

const Message = styled.div`
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-weight: normal;
    width: 100%;
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
`;

const useDialogClasses = makeStyles({
    contentRoot: {
        padding: '18px 40px',
    },
    paper: {
        margin: '10px',
    },
    underline: {
        borderBottom: '1px solid rgb(250 250 250)'
    }
});

const PopupDialog = ({ open, setOpen, title, children, onOK, onCancel, error }) => {
    const dialogClasses = useDialogClasses();

    const handleCancel = (e) => {
        setOpen(false);
        if (onCancel)
            onCancel(e);
    };

    const handleOk = (e) => {
        setOpen(false);
        onOK(e);
    };

    return (
        <Dialog
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose(event, reason)
                }
            }}
            disableEscapeKeyDown
            open={open}
            maxWidth="lg"
            classes={{ paper: dialogClasses.paper }}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent classes={{ root: dialogClasses.contentRoot }} >
                <ContentWrapper>
                    { error && <ErrorIcon style={{ width: 50 }}/> }
                    <Message>{children}</Message>
                </ContentWrapper>
            </DialogContent>
            <DialogActions>
                { onCancel && <Button disableRipple autoFocus onClick={handleCancel} color="primary">Cancel</Button> }
                { onOK && <Button disableRipple onClick={handleOk} color="primary">Ok</Button> }
            </DialogActions>
        </Dialog>
    );
};

export default PopupDialog;